import { Wrench, Shield, Zap, BarChart2, Settings, BookOpen } from 'lucide-react';
import company from '../data/company.json';
import styles from './ServicesSection.module.css';

const iconMap = { Wrench, Shield, Zap, BarChart2, Settings, BookOpen };

export default function ServicesSection() {
  return (
    <section className={`${styles.section} section`} id="services">
      <div className="container">
        <div className={styles.header}>
          <p className={styles.sectionLabel}>What We Offer</p>
<h2 className={styles.sectionTitle}>Our Services</h2>
          <p className={styles.subtitle}>
            From initial consultation to ongoing maintenance, we provide comprehensive support throughout the lifecycle of your industrial equipment.
          </p>
        </div>

        <div className={styles.grid}>
          {company.services.map((service, i) => {
            const Icon = iconMap[service.icon] || Wrench;
            return (
              <div key={i} className={styles.card}>
                <div className={styles.iconWrap}>
                  <Icon size={24} />
                </div>
                <h3 className={styles.title}>{service.title}</h3>
                <p className={styles.desc}>{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}